import { RootState } from 'bootstrap';
import { useSelector } from 'react-redux';
import { FederatedModules } from '../../types';
import { ProductTeaserContent } from '../../services/marketingContent.service';

export const getProductTeaser = (state: RootState) => (product: FederatedModules): ProductTeaserContent =>
  state.app.marketingContent.productTeasers[product];


export const useGetProductTeaser: ReturnType<typeof getProductTeaser> = (product) =>
  useSelector(getProductTeaser)(product);
